export default __webpack_public_path__ + "static/media/Goldman-Regular.f7a316a5.ttf";